import { Component } from '@angular/core';
import { DialogBaseComponent, DialogParams } from './dialog-base.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomainService } from './domain.service';

export interface FileSelectDialogParams extends DialogParams{
  header: string;
  label: string;
}

@Component({
    templateUrl: './file-select-dialog.component.html',
    standalone: false
})
export class FileSelectDialogComponent extends DialogBaseComponent<FileSelectDialogParams> {

  docFile: File;

  constructor(
      public config: DynamicDialogConfig<FileSelectDialogParams>,
      public dialogRef: DynamicDialogRef,
      public domainService: DomainService,
    ) {
      super(config, dialogRef, domainService);  
      Object.assign(this.config, {
        height: '200px',
        width: '600px',
      })
      this.prepare();
    } 

  async prepare() {
    this.isPageReady = true;
  }

  setDocFile(event: Event) {
    this.docFile = (event.target as HTMLInputElement).files[0];
  }

  async ok() {
    this.dialogRef.close(this.docFile);
  }

  cancel() {
    this.dialogRef.close(null);
  }

}
